import { Image as SitecoreImage } from '@sitecore-jss/sitecore-jss-react';
import styled from 'styled-components';
export const Image = styled(SitecoreImage) `
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: relative;
`;
``;
